// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div,
p {
    font-family: Roboto, "Helvetica Neue", Arial, sans-serif;
}

p {
    font-size: 16px;
    text-align: justify;
}`, "",{"version":3,"sources":["webpack://./src/app/components/avisoprivacidad/avisoprivacidad.component.css"],"names":[],"mappings":"AAAA;;IAEI,wDAAwD;AAC5D;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB","sourcesContent":["div,\r\np {\r\n    font-family: Roboto, \"Helvetica Neue\", Arial, sans-serif;\r\n}\r\n\r\np {\r\n    font-size: 16px;\r\n    text-align: justify;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
